var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33716 7.80532C8.93909 8.07106 8.47672 8.21154 8 8.21154C7.52331 8.21154 7.06094 8.07106 6.66287 7.80532L0.106531 3.42821C0.0701562 3.40392 0.0347187 3.37861 0 3.35257V10.5249C0 11.3473 0.666406 11.9999 1.47291 11.9999H14.5271C15.3482 11.9999 16 11.3326 16 10.5249V3.35254C15.9652 3.37864 15.9297 3.40402 15.8932 3.42833L9.33716 7.80532Z",
    fill: "#EBBC13"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.626562 2.64718L7.18291 7.02432C7.43109 7.19002 7.71553 7.27285 7.99997 7.27285C8.28444 7.27285 8.56891 7.18999 8.81709 7.02432L15.3734 2.64718C15.7658 2.38541 16 1.9473 16 1.47445C16 0.661419 15.3395 0 14.5276 0H1.47241C0.660531 3.12935e-05 0 0.66145 0 1.47524C0 1.9473 0.23425 2.38541 0.626562 2.64718Z",
    fill: "#EBBC13"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.0d3183b534d718bc867296afb989ad92.svg";
export { ForwardRef as ReactComponent };